var handleOrigin = function handleOrigin(data) {
  var _data$ads, _data$ads2, _data$ads3;
  return (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.id) ? "ads:".concat(data == null ? void 0 : (_data$ads2 = data.ads) == null ? void 0 : _data$ads2.id, "|campaignId:").concat(data == null ? void 0 : (_data$ads3 = data.ads) == null ? void 0 : _data$ads3.campaignId) : data == null ? void 0 : data.origin;
};
export default handleOrigin;